// components/HeroSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/HERO.png";
import heroImageMobile from "../assets/HERO_MOBILE.png";
import "../styles/HeroSection.css";

const HeroSection = () => {
    return (
        <section className="hero-section">
            {/* The Picture tag forces the browser to load specific images based on screen width */}
            <picture className="hero-background-img">
                <source media="(max-width: 768px)" srcSet={heroImageMobile} />
                <img src={heroImage} alt="Luxury Hair background" />
            </picture>

            <div className="hero-black-panel">
                <div className="hero-content">
                    <h1 className="hero-title">Luxury Hair</h1>
                    <p className="hero-subtitle">A True Mark of Distinction</p>
                    <Link to="/shop" className="hero-btn">
                        Shop Now
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;